module.exports = __webpack_public_path__ + "static/media/default_user.236334b1.png";